var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 10,
  viewBox: "0 0 16 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H10.7112V1.61147H0V0ZM0 3.22295H10.7112V4.83442H0V3.22295ZM0 6.4459H7.41542V8.05737H0V6.4459ZM14.8366 3.6935L10.7103 7.72138L9.64581 6.68117L8.48077 7.82129L10.7103 10L16 4.83442L14.8366 3.6935Z",
  fill: "#636766"
})));
export { SvgListCheck as ReactComponent };
export default __webpack_public_path__ + "2e2bd4e0bb2dc50ea5ea88177db6db27.svg";